import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { jqxGridModule } from 'jqwidgets-ng/jqxgrid';
import { jqxSchedulerModule } from 'jqwidgets-ng/jqxscheduler';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { HomeComponent } from './home/home.component';
import { AppRoutingModule } from './app-routing.module';
import {FormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

/* Add Amplify imports */
import { AmplifyUIAngularModule } from '@aws-amplify/ui-angular';

import Amplify from 'aws-amplify';
import awsconfig from '../aws-exports';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AsyncObservableComponent } from './async-observable/async-observable.component';
import { ProfileComponent } from './profile/profile.component';
import {AuthService} from './auth/auth.service';
import {WebsocketDataService} from './service/websocket-data.service';

import * as AWS from 'aws-sdk/global';
AWS.config.region = awsconfig.aws_cognito_region;

/* Configure Amplify resources */
// ALC done already in main.ts
// Amplify.configure(awsconfig);
const amplifyDebug = Amplify;



@NgModule({
  declarations: [ AppComponent, LoginComponent, SignUpComponent, HomeComponent, PageNotFoundComponent,
    AsyncObservableComponent, ProfileComponent ],
  imports: [ BrowserModule, jqxGridModule, jqxSchedulerModule, AppRoutingModule, FormsModule,
    /* Add Amplify module */ AmplifyUIAngularModule, HttpClientModule],
  bootstrap: [ AppComponent ],
  entryComponents: [ AppComponent ],
  // tslint:disable-next-line:max-line-length
  // ALC.Good tested article with lifecycle of Services explained. [What is the lifecycle of a service in Angular 5 \- Stack Overflow](https://stackoverflow.com/questions/50056446/what-is-the-lifecycle-of-a-service-in-angular-5)
  providers: [AuthService, WebsocketDataService]
})
export class AppModule { }

